import { useEffect } from 'react'
import styled from 'styled-components'
import Image from 'next/legacy/image'
import { Typography } from 'common/typography'
import { useBadge, useCourse } from 'querys/course'
import Stars from 'learning/stars'
import Link from 'next/link'
import { useRouter } from 'next/router'
import checkIfElementIsInViewport from 'utils/check-if-element-is-in-viewport'
import PaymentStatus from './payment-status'

const sections = [
  {
    title: 'Descripción',
    id: 'descripcion',
  },
  {
    title: 'Temario',
    id: 'temario',
  },
  {
    title: 'Valoraciones',
    id: 'valoraciones',
  },
  {
    title: 'Proyecto',
    id: 'proyecto',
  },
  {
    title: 'Comprar',
    id: 'comprar',
  },
]

const LandingNavigationTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0 24px;
  h1 {
    margin-bottom: 8px;
  }
  @media (min-width: 1024px) {
    margin: 24px 0 32px;
  }
`

const PaymentStatusStyled = styled.div`
  margin-bottom: 48px;
  @media (min-width: 1024px) {
    display: none;
  }
`

const LandingNavigationStyled = styled.div`
  position: sticky;
  top: var(--headerBlockSize);
  color: var(--neutral80);
  margin-bottom: 32px;
  background: var(--sky);
  z-index: 3;
  overflow-x: auto;
  max-width: 100%;
  .sections {
    box-shadow: inset 0px -1px 0px 0px var(--neutral80);
    display: flex;
    li:first-of-type a {
      padding-left: 0;
    }
  }
  .section {
    padding: 8px 12px;
    font-weight: bold;
    color: var(--neutral40);
    display: block;
  }
  .active {
    border-bottom: 4px solid var(--secondary);
    .section {
      color: var(--baseSecondary);
    }
  }
`

function LandingNavigation({ active, setActive }) {
  const { data: { title: courseTitle, project, is_free } } = useCourse()
  const { data: badgeInfo } = useBadge()
  const { asPath } = useRouter()

  const handleAnchorClick = (e, id) => {
    e.preventDefault()
    window.location.hash = `#${id}`
    setActive(id)
    const target = document.querySelector(`#${id}`)
    window.scrollTo(0, target.offsetTop)
  }

  useEffect(() => {
    const ids = sections.map(({ id }) => id)
    const idPosition = asPath.search('#')

    if (!idPosition) return

    const id = asPath.slice(idPosition + 1)

    if (ids.includes(id)) {
      setActive(id)
    }
  }, [asPath])

  return (
    <>
      <LandingNavigationTitle>
        {badgeInfo?.badge?.image && (
          <div className="img-container">
            <Image
              layout="fixed"
              width={56}
              height={56}
              src={badgeInfo.badge.image}
              alt={`Badge del ${courseTitle}`}
            />
          </div>
        )}
        <div>
          <Typography font="headline5" as="h1" data-cy="course-title">
            {courseTitle}
          </Typography>
          <Stars stars={5} align="start" />
        </div>
      </LandingNavigationTitle>
      <PaymentStatusStyled>
        <PaymentStatus />
      </PaymentStatusStyled>
      <LandingNavigationStyled className="landing-navigation" role="navigation" aria-label={courseTitle}>
        <ul className="sections">
          {sections.map(({ title, id }) => {
            if (!project && id === 'proyecto') return null
            if (is_free && id === 'comprar') {
              return (
                <li key={title} className={active === id ? 'active' : ''}>
                  <Link href="/precios" className="section">
                    {title}
                  </Link>
                </li>
              )
            }
            return (
              <li key={title} className={active === id ? 'active' : ''}>
                <a className="section" href={`#${id}`}>
                  {title}
                </a>
              </li>
            )
          })}
        </ul>
      </LandingNavigationStyled>
    </>
  )
}

export default LandingNavigation
